/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWEventTypeResponse } from './OWEventTypeResponse';
import {
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseFromJSONTyped,
    OWEventTypeResponseToJSON,
    OWEventTypeResponseToJSONTyped,
} from './OWEventTypeResponse';

/**
 * 
 * @export
 * @interface GetAllOverwolfEventTypesResponse
 */
export interface GetAllOverwolfEventTypesResponse {
    /**
     * 
     * @type {Array<OWEventTypeResponse>}
     * @memberof GetAllOverwolfEventTypesResponse
     */
    eventTypes: Array<OWEventTypeResponse>;
}

/**
 * Check if a given object implements the GetAllOverwolfEventTypesResponse interface.
 */
export function instanceOfGetAllOverwolfEventTypesResponse(value: object): value is GetAllOverwolfEventTypesResponse {
    if (!('eventTypes' in value) || value['eventTypes'] === undefined) return false;
    return true;
}

export function GetAllOverwolfEventTypesResponseFromJSON(json: any): GetAllOverwolfEventTypesResponse {
    return GetAllOverwolfEventTypesResponseFromJSONTyped(json, false);
}

export function GetAllOverwolfEventTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllOverwolfEventTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTypes': ((json['eventTypes'] as Array<any>).map(OWEventTypeResponseFromJSON)),
    };
}

export function GetAllOverwolfEventTypesResponseToJSON(json: any): GetAllOverwolfEventTypesResponse {
    return GetAllOverwolfEventTypesResponseToJSONTyped(json, false);
}

export function GetAllOverwolfEventTypesResponseToJSONTyped(value?: GetAllOverwolfEventTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventTypes': ((value['eventTypes'] as Array<any>).map(OWEventTypeResponseToJSON)),
    };
}

